import React from 'react';
import { VideoWrapper } from './Video.styles';
import VREPlayer from 'videojs-react-enhanced';
import 'video.js/dist/video-js.css';

// Components
import Page from '../../components/Page/Page';
import Wave from '../../components/Wave/Wave';

import { BASE_URL } from '../../config';

const Video = ({ content }) => {
  const playerOptions = {
    src: `${BASE_URL}${content[0].playerSRC[0]}`,
    controls: true,
    autoplay: 'play',
  };

  const videojsOptions = {
    fluid: true,
  };

  return (
    <Page borderTop={false}>
      <Wave />

      <VideoWrapper>
        <VREPlayer
          playerOptions={playerOptions}
          videojsOptions={videojsOptions}
          onReady={(player) => console.log(player)}
          onPlay={(e, _, second) => console.log('Play!')}
          onPause={(e, _, second) => console.log('Pause!')}
          onEnded={(e, _) => console.log('Ended!')}
        />
      </VideoWrapper>
    </Page>
  );
};

export default Video;
